import styled from 'styled-components';

export const AboutContent = styled.div`
  margin-top: 20px;
  h3 {
    color: #edbd2f;
    @media (max-width: 480px){
      font-size: 20px;
    }
  }

  p {
    margin: 16px 0;
    text-align: justify;
    line-height: 1.7;
  }

  ul {
    list-style-type: disc;
    padding-left: 25px;
  }

  li {
    padding: 10px 0;
  }
`;



// WEBPACK FOOTER //
// ./src/system/about/components.js